import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Gallery } from '../../../features/projects/interfaces/project.interface';
import { GalleryFilmstripComponent } from './gallery-filmstrip/gallery-filmstrip.component';
import { GalleryMasonryComponent } from './gallery-masonry/gallery-masonry.component';
import { GalleryShowcaseComponent } from './gallery-showcase/gallery-showcase.component';
import { GalleryTextBlockComponent } from './gallery-text-block/gallery-text-block.component';

@Component({
  selector: 'app-gallery-viewer',
  standalone: true,
  imports: [
    CommonModule,
    GalleryMasonryComponent,
    GalleryFilmstripComponent,
    GalleryShowcaseComponent,
    GalleryTextBlockComponent,
  ],
  templateUrl: './gallery-viewer.component.html',
  styleUrl: './gallery-viewer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryViewerComponent {
  @Input() gallery!: Gallery;
  @Input() assetBase = '';
  @Input() videoBase = '';
  @Input() showGalleryHeading = true;

  public get hasItems(): boolean {
    if (this.gallery?.layout === 'TEXT_BLOCK') {
      return true; // Text blocks don't require items
    }
    return (this.gallery?.items?.length ?? 0) > 0;
  }
}
